import * as Yup from "yup";

export interface StoryForm {
	header: string,
	content: string
}

export const StoryFormValidationSchema = Yup.object<StoryForm>().shape({
	header: Yup
		.string()
		.min(3, 'Header must be at least 3 characters')
		.required(),
	content: Yup
		.string()
		.max(8000, 'Maximum Characters exceeded!')
})